import pages from "./pages";
import tableHeaders from "./tableHeaders"

const constant = {
  ni_transport_contract_uri: "https://niconsul.com/seiwaev/ni/nyoibox/main/index.php?p=form&fmid=16&key=",
  ni_treatment_contract_uri: "https://niconsul.com/seiwaev/ni/nyoibox/main/index.php?p=form&fmid=80&key=",
  max_file_size: 5242880, // 5MB
  max_records_per_page: 10,
  scroll_able_records: 11,
  RESERVATION_TYPES: {'instant_reservation': 1, 'request_reservation':2, 'not_accepted': 3, 'Tel': 4},
  CALENDAR_RESERVATION_TYPES: {1: '〇', 2: '△', 3: '×', 4: 'TEL'},
  RECYCLE_TYPES: {0: '×', 1: '〇', 2: '△'},
  CALENDAR_DAY_OF_TIME_ZONE: {'AM': 'T01:00', 'PM': 'T13:00'},
  ZZ_DAY_OF_TIME_ZONE_LABEL: {'1': 'AM', '2': 'PM'},
  RESERVATION_ACCEPT_TO_RESERVATION_TYPE: {0: 1, 1: 2, 2: 3},
  DAY_OF_WEEKS: [
    {
      text: "日",
      value: 0
    },
    {
      text: "月",
      value: 1
    },
    {
      text: "火",
      value: 2
    },
    {
      text: "水",
      value: 3
    },
    {
      text: "木",
      value: 4
    },
    {
      text: "金",
      value: 5
    },
    {
      text: "土",
      value: 6
    }
  ],
  work_order_type: {
    work: '01',
    discharge: '05',
    transshipment_storage: '06',
    others: '07',
    disposal: '04',
    transportation: '02',
    transportation_disposal: '03',
  },
  disable_zz_jw_units_create_work_order: {
    '05': [], // discharge
  },
  default_disable_zz_jw_units_create_work_order: ['5'],
  default_disable_zz_jw_units_create_work_reservation: ['5'],
  ZZ_DAY_OF_TIME_ZONE_ID_AM: '1',
  ZZ_DAY_OF_TIME_ZONE_ID_PM: '2',
  zz_reservation_status_1: {
    not_set: '1',
    employee_setting: '2',
    vehicle_setting: '3',
    vehicle_employee_setting: '4',
    confirm: '5',
    change_request: '6',
    cancel: '7',
  },
  zz_reservation_status_2: {
    unnecessary: '0',
    before_request_sub_contractor: '1',
    currently_request_sub_contractor: '2',
    contractor_approval: '3',
  },
  zz_system_code_categories: {
    time_zone_display_setting_start: '10',
    time_zone_display_setting_finish: '11',
    max_reservation_months: '6',
    max_reservation_nums: '7',
    reservation_start_time_am: '8',
    reservation_start_time_pm: '9',
    day_for_daily_report: '16',
    receive_reply: '13'
  },
  statusHandle: {
    'disposal_complete': '#808080',
    'disposal_incomplete': '#f9b115',
    'disposal_complete_gray': '#404040',
    'cancel': '#bfbfbf',
    'complete': '#808080',
    'incomplete': '#f9b115',
  },
  workOrderTypeBgColor: {
    '01': '#616161',
    '02': '#4285f4',
    '03': '#7cb342',
    '04': '#f6bf26',
    '05': '#f4511e',
    '06': '#891457',
    '07': '#a79b8e',
  },
  zzReservationStatus1BgColor: {
    '1': "#d7c8c1",
    '2': "#fff3cd",
    '3': "#fff3cd",
    '4': "#cce5ff",
    '5': "#c3e6cb",
    '6': "#f0abfc",
    '7': "#e2e3e5",
  },
  zzReservationStatus2BgColor: {
    '1': '#d50000',
    '2': '#e4c441',
    '3': '#4285f4',
  },
  zzReservationSiteId: {
    company_site: '1',
    own_site: '2',
  },
  zzOwnId: {
    is_own: '1',
    is_not_own: '0',
  },
  zzReservationSiteIdBgColor: {
    '1': '#E67C73',
    '2': '#178045',
  },
  zzReservationSiteText: {
    '1': '事',
    '2': '静',
  },
  zzReservationTypeId: {
    instant_reserve: '1',
    request_reserve: '2',
    not_accepted: '3',
    tel: '4',
  },
  zzReservationTypeIdBgColor: {
    '1': '',
    '2': '#F09300',
  },
  zzReservationTypeText: {
    '1': '',
    '2': 'リ',
  },
  zzReservationFrequencyTypeId: {
    date_specific: '1',
    regularly: '2',
  },
  zzReservationFrequencyTypeIdBgColor: {
    '1': '',
    '2': '#33B679',
  },
  zzReservationFrequencyTypeText: {
    '1': '',
    '2': '定',
  },
  DEPARTMENT: {
    environmental_management_department: '160'
  },
  zzValuablesInvolvedType: {
    total: '1',
    valuables: '2',
    no: '3',
  },
  zzJwQuantityConfirmationCompanyTypes: {
    none: '00',
    discharger: '01',
    disposal: '02',
    trans1st: '03',
    trans2nd: '04',
    trans3rd: '05',
    trans4th: '06',
    trans5th: '07',
  },
  zzQuantityConfirmationUnits: {
    kg: '1',
    l: '2',
    m3: '3',
    piece: '4',
  },
  zzManifestStages: {
    first: '1',
    second: '2',
  },
  zzManifestTypes: {
    paper: '1',
    electronic: '2',
  },
  JWNETDateByControlNumber:{
    inquiry: "3101",
    book_registration: "0404",
    transport_report: "1000",
    disposal_report: "1500",
    final_disposal: "2000"
  },
  zzJwnTransmissionTaskStatuses:{
    reservation: 1,
  },
  zzJUnits: {
    t: '1',
    m3: '2',
    kg: '3',
    l: '4',
    piece: '5',
  },
  zzCheckUpWorkItems: {
    work: '1',
    sale: '2',
    rental: '3',
    preparations: '4',
    work_height: '5',
    oxygen: '6',
    chemical: '7',
    gas: '8',
    measures: '9',
    container_exchange: '10',
    returned: '11',
    campus_entrance_education: '12',
  },
  workflowStatus: {
    submit: 1,
    approve: 2,
    back_submit: 4,
    back_before_approved: 3,
    clear: 5,
    draft: 7,
  },
  ZzUpdatePermissions: {
    registration: '1',
    reference: '2',
    admin: '3'
  },
  screens: {
    home: { id: 1, name: "home" },
    estimates: { id: 2, name: "estimates" },
    project: { id: 3, name: "projects" },
    schedule: { id: 4, name: "schedules" },
    schedule_car: { id: 5, name: "schedules-car" },
    daily_report_registration: { id: 6, name: "daily-report-registration" },
    daily_report_search_approve: {
      id: 7,
      name: "daily-reports-search-approve"
    },
    daily_report_search_maintenance: {
      id: 8,
      name: "daily-reports-search-maintenance"
    },
    manifests: { id: 9, name: "manifests" },
    inquiries: { id: 10, name: "inquiries" },
    calendar_setting: { id: 11, name: "calendar-settings" },
    system_setting: { id: 12, name: "system-setting" }
  },
//only write constant above this injects
  ...pages,
  ...tableHeaders
};

export default constant;
